import { useTheme } from "@mui/material";
import { useFeatureGate } from "@statsig/react-bindings";
import { useHistory, useLocation } from "react-router-dom";

import { Box } from "@/Components/v2/atoms/Box";
import { OutlinedButton } from "@/Components/v2/atoms/Button";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";

import ScenarioBuilderReport from "../../images/ScenarioBuilderReport.png";

export const ScenarioBanner = () => {
  const theme = useTheme();
  const backgroundColor = theme.palette.banner.background;

  const history = useHistory();
  const location = useLocation();
  const { value: isScenarioBuilderV3Enabled } = useFeatureGate(featureFlag.scenarioBuilderV3);

  const handleClick = () => {
    history.push(isScenarioBuilderV3Enabled ? "/scenarios-v3/all/new" : "/scenarios-v2/all/new", {
      background: location,
    });
  };

  return (
    <Stack
      sx={{ backgroundColor: backgroundColor, borderRadius: 4 }}
      direction="row"
      justifyContent="space-between"
    >
      <Stack sx={{ padding: 4 }}>
        <Typography variant="h2" fontSize={20} fontWeight={600} pb={2}>
          What’s next?
        </Typography>
        <Typography variant="body2" pb={2} maxWidth="700px">
          The recommendations and insights on this page are a guide only and may not take into
          account channel synergies, strategic goals or long-term impacts.
        </Typography>
        <Typography variant="body2" pb={2} maxWidth="700px">
          To simulate the result of increased investment, we recommend forecasting or optimizing a
          scenario using Scenario Builder.
        </Typography>
        <OutlinedButton onClick={handleClick}>+ Build New Scenario</OutlinedButton>
      </Stack>
      <Box>
        <img src={ScenarioBuilderReport} alt="Scenario Builder Report" width="400px" />
      </Box>
    </Stack>
  );
};
